import type { FormValuesModel } from '../types/form-value.model';
import type { MessageCreateModel } from '@/features/Shared';
import type { UserModel } from '@/features/Shared/users/model/types/users.model';

export const toFormValuesModel = (model: MessageCreateModel): FormValuesModel => {
	return {
		title: model.content.title.text,
		body: model.content.body?.text ?? '',
		users: model.recipientGroups.flatMap((group) =>
			group.recipients.map((recipient) => recipient.id)
		),
	};
};

export const toMessageCreateModel = (
	formValues: FormValuesModel,
	users: UserModel[]
): MessageCreateModel => {
	const groups: Record<string, typeof users> = {};
	users.forEach((user) => {
		const orgId = user?.organizationId ?? '';
		if (!groups[orgId]) {
			groups[orgId] = [];
		}
		if (user) {
			groups[orgId].push(user);
		}
	});

	const recipientGroups = Object.entries(groups).map(([orgId, users]) => ({
		groupNumber: 0,
		orgId,
		recipients: users.map((user) => ({
			type: 'user',
			id: user?.id ?? '',
		})),
	}));

	return {
		content: {
			title: {
				text: formValues.title,
			},
			body: {
				text: formValues.body,
			},
		},
		recipientGroups,
	};
};
